export const environment = {
    production: true,
    serviceUrl: 'https://backend.childcarewow.net/api',
    paymentGatewayUrl: 'https://backend.childcarewow.net/api',
    GatewayScript: 'https://checkout.forte.net/v2/js',
    Gatewaytime :'https://checkout.forte.net/getUTC',
    useHash: false,
    configFile: 'assets/layout/config/config.prod.json',
    firebaseConfigFile: 'assets/layout/firebase/firebase.prod.json',
    path: '',
};
